import 'extensions/star-rating-svg/jquery.star-rating-svg';

export default () => {
    const $starRating = $('[data-rating]');
    if ($starRating.length) {
        $starRating.each((i, rating) => {
            const $rating = $(rating);
            $rating.starRating($rating.data('rating'));
        });
    }
};
